import React from 'react'

import { useDrag } from 'react-dnd'

import {
  Button,
  Close,
  Drag,
  Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string, number, shape } from 'prop-types'

import useUseCaseTranslate from 'Pods/LazyLoaded/UseCaseAreaSidebar/hooks/useUseCaseTranslate'

import MediaRenderer from '../../../../../MediaRenderer/MediaRenderer'

const ITEM_TYPE = 'PENDING_MEDIA'

function UploadMediaItem({
  media,
  index,
  onRemove: handleRemove,
}) {
  const { t } = useUseCaseTranslate()
  const [{ isDragging }, drag] = useDrag({
    item: {
      type: ITEM_TYPE,
      id: media.id,
      index,
      media,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const opacity = isDragging ? 0.4 : 1
  const containerClasses = [
    'use-cases-area__media-item',
    isDragging ? 'use-cases-area__media-item--dragging' : '',
  ].filter(Boolean).join(' ')

  return (
    <div
      ref={drag}
      className={containerClasses}
      style={{ opacity }}
      data-testid={`media-item-${media.id}`}
    >
      <div className="use-cases-area__media-item-preview">
        <div
          className="use-cases-area__media-item-drag-handle"
          aria-label={t('form.dragToReorder')}
        >
          <Icon svgComponent={Drag} size="small" />
        </div>
        <MediaRenderer
          url={media.preview || media.url}
          type={media.type}
          classPrefix="use-cases-area__media"
          containerClass={isDragging ? 'use-cases-area__media--dragging' : ''}
          externalId={media.externalId}
          source={media.source}
          file={media.file}
        />
        <Button
          icon={<Icon svgComponent={Close} size="small" />}
          onClick={handleRemove}
          size="xsmall"
          type="ghost"
          variant="only-icon"
          aria-label={t('form.removeMedia')}
          customClass="use-cases-area__media-item-remove"
        >
          {t('form.removeMedia')}
        </Button>
      </div>
      {media.name && (
        <span className="cgt-body-base use-cases-area__media-item-name">
          {media.name}
        </span>
      )}
    </div>
  )
}

UploadMediaItem.propTypes = {
  media: shape({
    id: string.isRequired,
    type: string.isRequired,
    url: string,
    preview: string,
  }).isRequired,
  index: number.isRequired,
  onRemove: func.isRequired,
}

export default UploadMediaItem
